/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';

import { ApplicationFormPageAgent, getAgent } from './agent';
const is = require('is_js');

const SERVICE_NAME = 'FormPageService';

@injectable()
export class ApplicationFormPageService {
  public agent: ApplicationFormPageAgent;
  private NewWorkPermitData: any;
  static displayName = 'ApplicationFormPageService';
  constructor() {
    this.agent = getAgent();
  }
  public setNewWorkPermitData = (data: any) => {
    this.NewWorkPermitData = { ...this.NewWorkPermitData, ...data };
  };

  public getNewWorkPermitData = () => {
    let data = this.NewWorkPermitData;
    return { data };
  };

  public getCities = (args: any) => {
    return this.agent.getCities(args);
  };
}
